export const INITIAL_TRANS_ID_STORE_NAME = 'initial-trans-id'

export const TPL_CODE = '0100'
export const OD_CODE = '0110'
